import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-pressed", "onClick"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'SegmentedControl',
    props: {
        options: {},
        modelValue: {},
        label: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        // SYNC: see ../../_SYNC.md.
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "df-segmented",
                role: "group",
                "aria-label": __props.label
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: opt.value,
                        type: "button",
                        class: _normalizeClass(["df-segmented__btn", { 'is-active': opt.value === __props.modelValue }]),
                        "aria-pressed": opt.value === __props.modelValue,
                        onClick: ($event) => (emit('update:modelValue', opt.value))
                    }, _toDisplayString(opt.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
